import { render } from "./createTarifForm.vue?vue&type=template&id=6ebfd070"
import script from "./createTarifForm.vue?vue&type=script&lang=js"
export * from "./createTarifForm.vue?vue&type=script&lang=js"

import "./createTarifForm.vue?vue&type=style&index=0&id=6ebfd070&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__